namespace Solovis.Portal.UnifiedSearchService {

    export var jInputElement;

    export type SearchResult =
        | { label: string; entityId: number }
        | { label: string; investmentId: number }
        | { label: string; tagId: number; tagSetId: number}
        | { label: string; reportDefinitionId: number }
        | { label: string; contactId: number }
        | { label: string; userId: number }
        | { label: string; managerId: number }
        | { label: string; showExtendedResults: boolean; originalQuery: { filterText: string; excludeDemotedItems: boolean } };

    export function showExtendedSearchResultsDialog(options): void {        
        Solovis.Site.Search.ExtendedSearchResultsDialog.showDialog(options);
    }

    export function initialize(inputElement: JQuery | HTMLElement | string): void {
        // inputElement should be a DOM input element or selector for the unified search text box.
        var self = this;

        $(function () {
            function findItems(autocompleteRequest, responseCallback) {
                var options = {
                    query: { filterText: autocompleteRequest.term, excludeDemotedItems: true },
                    offset: 0,
                    maxItems: 10
                };

                var originalQuery = options.query;

                Solovis.Rpc.invoke("~/Search/FindItems", options,
                    function (response, success) {
                        if (success) {
                            var data = response.result.data;
                            if (response.result.hasMoreData || response.result.hasExcludedItems) {
                                data.push({
                                    label: "More Results",
                                    showExtendedResults: true,
                                    originalQuery: originalQuery
                                });
                            }

                            responseCallback(data);
                        }
                        else {
                            // TODO: report error somehow
                            responseCallback([]);
                        }
                    });
            }

            self.jInputElement = $(inputElement);
            var jInputElement = self.jInputElement;
            jInputElement.val("");

            var autoComplete = jInputElement
                .autocomplete({
                    minLength: 1,
                    source: findItems,
                    focus: function (event, ui) {
                        if (ui.item)
                            jInputElement.val(ui.item.label);
                        return false;
                    },
                    select: function (event, ui) {
                        if (ui.item) {
                            jInputElement.val(ui.item.label);
                            Solovis.Portal.UnifiedSearchService.selectionHandler(ui.item);
                        }
                        return false;
                    },
                    search: function (event, ui) {
                        // NOTE: spinners are built into the control
                        this.waitImageDiv = Solovis.UI.StockAnimations.createSpinningCircles({
                            diameter: "20px",
                            top: $(this).position().top + 16,
                            left: $(this).width() + 10
                        })
                            .insertAfter(this);
                    },
                    response: function (event, ui) {
                        if (this.waitImageDiv) {
                            this.waitImageDiv.remove();
                        }
                    }
                })
                .data("ui-autocomplete");

            autoComplete._renderItem = function (ul, item) {

                var itemLink = self._createItemLink(item);

                var itemElement = $("<li>").append(itemLink);
                itemElement.appendTo(ul);
                return itemElement;
            };

            autoComplete._resizeMenu = function () {
                /*
                 * jqueryui-autocomplete fails to wrap long text the first time the menu opens.  Subsequent
                 * menu openings wrap long text correctly.
                 * defining this empty extension point causes long text in the first menu opening to
                 * wrap correctly.
                 */
            };            
        });
    }

    export function _createItemLink(item: SearchResult) {
        var label = item.label;

        var itemLink = $("<a>")
            .text(label);

        if ('tagId' in item) {
            Solovis.UI.Icons.createTagIcon({ "padding-right": "10px" })
                .prependTo(itemLink);
        }
        else if ('investmentId' in item) {
            Solovis.UI.Icons.createInvestmentIcon({
                "left": "-2px",
                "padding-right": "4px"
            })
                .prependTo(itemLink);
        }
        else if ('entityId' in item) {
            Solovis.UI.Icons.createEntityIcon({ "padding-right": "10px" })
                .prependTo(itemLink);
        }
        else if ('contactId' in item) {
            Solovis.UI.Icons.createContactIcon({ "padding-right": "10px" })
                .prependTo(itemLink);
        }
        else if ('managerId' in item) {
            Solovis.UI.Icons.createManagerIcon({ "padding-right": "10px" })
                .prependTo(itemLink);
        }
        else if ('reportDefinitionId' in item) {
            Solovis.UI.Icons.createReportIcon({ "padding-right": "10px" })
                .prependTo(itemLink);
        }
        else if ('userId' in item) {
            Solovis.UI.Icons.createUserIcon({ "padding-right": "10px" })
                .prependTo(itemLink);
        }

        if ('showExtendedResults' in item && item.showExtendedResults) {
            itemLink = $("<a>")
                .append(Solovis.UI.Icons.createMoreResultsIcon({ "padding-right": "10px" }))
                .append(
                $("<strong>").text(label)
                );
        }

        return itemLink;
    }

    export function clearSearchBox() {
        Solovis.Portal.UnifiedSearchService.jInputElement.val("");
    }

    export var selectionHandler = function (item: SearchResult) {
        // The selectionHandler may be replaced by a page to provide custom handling for the search selection.
        // Usually, any page replacing this should call the defaultSelectionHandler if the replacement does not
        // handle the selection.

        Solovis.Portal.UnifiedSearchService.defaultSelectionHandler(item);
    }

    export var pageSelectionHandler = null;

    export function defaultSelectionHandler(item: SearchResult) {
        // The default selection handler will have the normal logic for handling a selection.

        Solovis.Portal.UnifiedSearchService.clearSearchBox();

        if (Solovis.Portal.UnifiedSearchService.pageSelectionHandler) {
            if (Solovis.Portal.UnifiedSearchService.pageSelectionHandler(item)) {
                // The pageSelectionHandler handled the search request.
                return;
            }
        }

        if ('showExtendedResults' in item && item.showExtendedResults) {
            UnifiedSearchService.showExtendedSearchResultsDialog({
                query: item.originalQuery
            });
            return;
        }

        // The following urls represent our standard routing for handling unified search.
        var url = null;
        if ('entityId' in item) {
            url = (Solovis as any).Reports.ReportLinker.getReportLink({
                reportAlias: "AssetInfo",
                parameters: { entityOrInvestment: { entityId: item.entityId } },
                autoRun: true,
                collapseConfigSection: false
            });
        }
        else if ('investmentId' in item) {
            url = (Solovis as any).Reports.ReportLinker.getReportLink({
                reportAlias: "AssetInfo",
                parameters: { entityOrInvestment: { investmentId: item.investmentId } },
                autoRun: true,
                collapseConfigSection: true
            });
        }
        else if ('tagId' in item) {
            url = (Solovis as any).Reports.ReportLinker.getReportLink({
                reportAlias: "TagAssoc",
                parameters: { tag: { tagId: item.tagId, tagSetId: item.tagSetId } },
                autoRun: true,
                collapseConfigSection: true
            });
        }
        else if ('contactId' in item) {
            url = (Solovis as any).Reports.ReportLinker.getReportLink({
                reportAlias: "ContactSummary",
                parameters: { contact: { contactId: item.contactId } },
                autoRun: true,
                collapseConfigSection: true
            });
        }
        else if ('managerId' in item) {
            url = Solovis.resolveUrl((Solovis as any).Reports.ReportLinker.getManagerLink(item.managerId));
        }
        else if ('reportDefinitionId' in item) {
            url = Solovis.resolveUrl("~/Report/GoToReport?id=" + item.reportDefinitionId);
        }
        else if ('userId' in item) {
            url = (Solovis as any).Reports.ReportLinker.getReportLink({
                reportAlias: "UserSummary",
                parameters: { user: { userId: item.userId } },
                autoRun: true,
                collapseConfigSection: true
            });
        }
        else {
            url = null;
        }

        if (url) {
            window.location.href = url;
        }
    };

}
